/* global StripeModal */
import StripeModal from '../commons/StripeModal';

var cookieName = 'sellsyAcceptCookie';
				
window.writeAcceptCookie = function(value) {
	var date = new Date();
	date.setTime(date.getTime() + (50 * 24 * 60 * 60 * 1000));
	var expires = "; expires=" + date.toGMTString();
	document.cookie = cookieName + "=" + value + expires + "; path=/";
};

window.readAcceptCookie = function(){
	var nameEQ = cookieName + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' '){
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0){
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
};
				
function iePlaceholder(){
	$('[placeholder]').focus(function() {
		var input = $(this);
		if (input.val() === input.attr('placeholder')) {
			input.val('');
			input.removeClass('placeholder');
		}
	}).blur(function() {
		var input = $(this);	
	if (input.val() === '' || input.val() === input.attr('placeholder')) {
			input.addClass('placeholder');
			input.val(input.attr('placeholder'));
			input.css("color", "#878787");
		}
	}).blur();

	$('[placeholder]').parents('form').submit(function() {
		$(this).find('[placeholder]').each(function() {
			var input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
			}
		});
	});
};

window.DocExternalOverview = {
	
	payHash		: '',
	updateHash	: '',
	
	initPay : function(hash){
        
		DocExternalOverview.payHash = hash;
		
		$('input[name=deadline]').unbind('change').bind('change', function(){
			var deadlineID = $(this).val();
			DocExternalOverview.refreshPayButtons(deadlineID);
		});
		
		if($('input[name=deadline]').length > 0){
			$('input[name=deadline]:not(:disabled):first').attr('checked', 'checked').trigger('change');
		}else{
			DocExternalOverview.refreshPayButtons('');
        }
	},

    refreshConditions : function(){
		if ($('#paymentInfos_conditionDocAccepted').prop('checked')) {
            $('.paymentInfos').removeClass('disableClick');
            $('.paymentInfos a, .paymentInfos button').removeClass('btn-disabled');
            $('.payment-content').removeAttr('onClick');
		} else {
            $('.paymentInfos').addClass('disableClick');
            $('.paymentInfos a, .paymentInfos button').addClass('btn-disabled');
            $('.payment-content').attr('onClick', 'DocExternalOverview.openErrorConditions(event)');
		}
    },

    openErrorConditions : function(e){
       e.preventDefault();
       e.stopImmediatePropagation();
        $('#modalConditionNeeded').modal('show');
    },

    initCampaignInscription : function(hash){
        DocExternalOverview.updateHash = hash;
		
		$('#quickpay .canToggle').click(function(){
			if ($(this).next().hasClass('hidden')){
				$(this).next().slideDown('normal',function(){
					$(this).removeClass('hidden');
				});
				
				if($('#quickPay_lang').val() == "en"){
					$(this).find('.togglerText').html('Fold');
				} else {
					$(this).find('.togglerText').html('Replier');
				}
				
			} else {
				$(this).next().slideUp('normal', function(){
					$(this).addClass('hidden');
				});
				
				if($('#quickPay_lang').val() == "en"){
					$(this).find('.togglerText').html('Unfold');
				} else {
					$(this).find('.togglerText').html('Déplier');
				}
			}
		});
    },

    updateCampaignInscriptionRgpd : function(){
		var subscribe = '', unsubscribe = '';
		$('input[type=checkbox]').each(function () {
			if (this.checked) {
				subscribe += $(this).attr('name') + ',';
			} else {
				unsubscribe += $(this).attr('name') + ',';
			}
		});

    	$.ajax({
            url     : '/quickpay/rgpdoptin',
			type	: 'POST',
			dataType: 'json',
			data	: {
				hash		: DocExternalOverview.updateHash,
				unsubscribe	: unsubscribe,
				subscribe	: subscribe
			},
			success : function(data){
				$('#inscriptions').hide();
				$('#inscriptionCampaignValidate').show();
			}
		});
    },

    updateCampaignInscription : function(campaignType){
		$.ajax({
			url		: '/quickpay/optin',
			type	: 'POST',
			dataType: 'json',
			data	: {
				hash			: DocExternalOverview.updateHash,
                campaign		: campaignType,
				unsubscribeAll	: $('#paymentInfos_unsubscribeAll').is(':checked') == true ? 'N' : 'Y',
				useCampaignAll	: $('#useCampaignAll').val()
			}
		});

    },

    updateCampaignAll : function(campaignType){
		if(campaignType == 'all'){
			//On coche/décoche tous les types de campagne
			if($('#paymentInfos_unsubscribeAll').is(':checked')){
				$("#paymentInfos_unsubscribeEmail").prop("checked", true);
				$("#paymentInfos_unsubscribeSMS").prop("checked", true);
				$("#paymentInfos_unsubscribePhone").prop("checked", true);
				$("#paymentInfos_unsubscribeMail").prop("checked", true);
			} else {
				$("#paymentInfos_unsubscribeEmail").prop("checked", false);
				$("#paymentInfos_unsubscribeSMS").prop("checked", false);
				$("#paymentInfos_unsubscribePhone").prop("checked", false);
				$("#paymentInfos_unsubscribeMail").prop("checked", false);
			}
		} else if(campaignType != 'custom') {
			//On Vérifie si tous le stypes de campagnes sont cochés ou non pour cocher/décocher la checkbox All
			var publicLinkEmail = $('#publicLinkEmail').val();
			var publicLinkSMS = $('#publicLinkSMS').val();
			var publicLinkPhone = $('#publicLinkPhone').val();
			var publicLinkMail = $('#publicLinkMail').val();
			
			if(((publicLinkEmail === "Y" && $('#paymentInfos_unsubscribeEmail').is(':checked')) || publicLinkEmail === "N") && ((publicLinkSMS === "Y" && $('#paymentInfos_unsubscribeSMS').is(':checked')) || publicLinkSMS === "N") &&
					((publicLinkPhone === "Y" && $('#paymentInfos_unsubscribePhone').is(':checked')) || publicLinkPhone === "N") && ((publicLinkMail == "Y" && $('#paymentInfos_unsubscribeMail').is(':checked')) || publicLinkMail === "N")){
				$("#paymentInfos_unsubscribeAll").prop("checked", true);
			} else {
				$("#paymentInfos_unsubscribeAll").prop("checked", false);
			}
		}
    },
	
	refreshPayButtons : function(deadlineID, customerSelected){

        var saveCustomerCard = $('input[name="saveCustomer"]:checked').val();

        var payData = {
            hash		: DocExternalOverview.payHash, 
            deadlineid	: deadlineID,
            saveCustomer: saveCustomerCard
        }
        
        if(customerSelected) {
            data['customer'] = customerSelected;
        }

		$.ajax({
			url		: '/quickpay/payment?lang=' + window.App.lang,
			type	: 'POST',
			dataType: 'json',
            data	: payData,
			beforeSend : function(){
				var $loader = $('<div id="payloader" style=""></div>');
				$loader.append('<i class="fa fa-spin fa-spinner fa-40"></i>');
				$loader.append('<p>' + window.i18n.__('Chargement des moyens de paiement') + '...</p>');
				$loader.appendTo('.payment-content').fadeIn('fast');
				
				$('.paymentInfos').empty();
			},
			success : function(data){
				
				if(data.status && data.status == 'payment_in_progress'){
					
					var $payBlock = $('<div class="alert alert-info">' + data.text + '</div>');
					$payBlock.appendTo('.paymentInfos');
					
				} else {
					
					for(var i in data.paymentsInfo){

						if(data.paymentsInfo[i] != null){

                            var $payBlock = $('<div class="'+i+'"></div>');
							switch(i) {
                                case 'stripe' : 
                                    if(data.paymentsInfo[i]) {
                                        new StripeModal(payData, ".paymentInfos", true);
                                    } else {
                                        Push.error(window.i18n.__("Une erreur est survenue, contacter le commerçant."));
                                    }
								break;
                                    
								default:
									$payBlock.append(data.paymentsInfo[i].html);
									$payBlock.appendTo('.paymentInfos');
									break;
							}

                            $(`.${i}`).find("button, a").on('click',  _.debounce(() => {
								if ($('#paymentInfos_conditionDocAccepted').prop('checked')) {
									DocExternalOverview.acceptCondition()
								}
							}))

						}
					}
					
				}
				
                if ($('#paymentInfos_conditionDocAccepted').length > 0) {
                    DocExternalOverview.refreshConditions();
                }
				
				$('#payloader').fadeOut('fast', function(){$(this).remove();});
			}
		});
	},

	acceptCondition : function() {
		window.SellsyJS.WebServiceCaller.post(
			`/quickpay/save_condition_acceptation`,
			{},
			{
				hash : DocExternalOverview.payHash
			}
		);
	},
};

window.PublicEsign = {
	
	init : function(){
		$('#modalQuickpay').unbind('hidden.bs.modal');
		
		$(document).on('hidden.bs.modal', '#modalQuickpay', function (e) {
			Utils.reload();
		});

        let conditionBloc = $('#paymentInfos_conditionDocAccepted');
        let conditionsNeeded = (conditionBloc.length > 0);
        let signatureUrl = $('#signature-url').val();
        if (conditionsNeeded) {
            conditionBloc.on('change', function(){
                PublicEsign.refreshConditionsForSign();
            }).change();
        } else if (signatureUrl) {
            $('#signature-button').attr('onClick', signatureUrl);
        }
	},
	
	gotoSign : function(url){
        document.location.href = url;
    },

    refreshConditionsForSign : function(){
        let signatureUrl = $('#signature-url').val();
        if ($('#paymentInfos_conditionDocAccepted').prop('checked') && signatureUrl) {
            $('#signature').removeClass('disableClick');
            $('#signature-button').removeClass('btn-disabled');
            $('#signature-button').attr('onClick', signatureUrl);
        } else {
            $('#signature').addClass('disableClick');
            $('#signature-button').addClass('btn-disabled');
            $('#signature-button').removeAttr('onClick');
        }
    },
};

window.Timer = (function() {
	'use strict';

	var _time = {
		start: 0,
		end: 0
	};
	var self = {};

	self.running = false;

	self.getTime = function() {
		return _time.end - _time.start;
	};

	self.getCurrentTime = function() {
		return $.now() - _time.start;
	};

	self.start = function() {
		_time.start = new Date().getTime();
		_time.end = 0;
		self.running = true;
	};

	self.stop = function() {
		_time.end = new Date().getTime();
		self.running = false;
	};
	
	return self;
});

window.OptIn = {
	updateCampaign: function (event, hash, linkedtype, linkedid, corpid) {

		var $content = $(event.currentTarget).closest('#input-campaigns');
		var url = location.protocol + '//' + location.hostname + '/optin/update/' + hash;
		var subscriptions = {};

		$.each($content.find('input.campaignSubscription'), function (key, input) {
			subscriptions[$(input).attr('name')] = ($(input).prop('checked')) ? 'N' : 'Y';
		});

		$.ajax({
			type: 'POST',
			url: url,
			dataType: 'json',
			data: {
				linkedtype: linkedtype,
				linkedid: linkedid,
				corpid: corpid,
				subscriptions: subscriptions
			},
			async: false,
			success: function (res) {
				if (res.status == 'ok') {
					$('#inscriptionCampaignValidate').fadeIn();
					$('#input-campaigns').fadeOut();
				}
			}
		});
	}
};

window.PublicTracking = {
	
	start	: null,
	
	documentInit	: function(doctype, docid, corpid){

		var date = new Date();
		PublicTracking.start = date.getTime() / 1000;	
		
		var url = location.protocol + '//' + location.hostname + '/tracking';

        window.addEventListener('unload', () => {
            var date		= new Date();
            var current		= date.getTime() / 1000;
            var duration	= (current - PublicTracking.start);
            
            if (navigator.sendBeacon) {
                SellsyJS.WebServiceCaller.sendBeacon(url + '/visit', JSON.stringify({
                    doctype	: doctype,
                    docid	: docid,
                    corpid: corpid,
                    duration: duration,
                    start	: PublicTracking.start,
                    end		: current,
                }));
                
            } else {
                $.ajax({
                    type	: 'POST',
                    url     : url + '/visit',
                    data	:  {
                        doctype	: doctype,
                        docid	: docid,
                        corpid: corpid,
                        duration: duration,
                        start	: PublicTracking.start,
                        end		: current,
                    },
                    async	: false,
                });
            }

        } , false);

		$('.btnDownload').bind('click', function(){

			$.ajax({
				type	: 'POST',
                url     : url + '/download',
				data	: {
					doctype	: doctype,
					docid	: docid,
					corpid: corpid,
				},
				async	: false,
			});
		});
	},
	
	
	proposalInit	: function (proposaltype, proposalid, corpid) {
		
		var date = new Date();
		PublicTracking.start = date.getTime() / 1000;
		
		var url = location.protocol + '//' + location.hostname + '/proposal';

		window.addEventListener('unload', () => {
			
			var date		= new Date();
			var current		= date.getTime() / 1000;
			var duration	= (current - PublicTracking.start);
			
			var data =  {
				duration	: duration,
				start		: PublicTracking.start,
				end			: current,
				corpid		: corpid,
			};

			if (navigator.sendBeacon) {
				SellsyJS.WebServiceCaller.sendBeacon(
					url + "/track" + "/" + proposaltype + "/" + proposalid,
					JSON.stringify(data)
				);
			} else {
				$.ajax({
					type	: 'POST',
					url: url + "/track" + "/" + proposaltype + "/" + proposalid,
					data	: data,
					async	: false,
				});
			}
		}, false);
		
		
		
		$('.btnDownload').bind('click', function(){

			
			$.ajax({
				type	: 'POST',
                url: url + "/download"+ "/" + proposaltype + "/" + proposalid,
				data	: {corpid: corpid},
				async	: false,
			});
		});
	}
};

$(function() {

	if (readAcceptCookie() === null){
		$('#cookiesAccept').show();
    }

    $('.btn-change-language').bind('click', function () {
        LocalizationHelpers.changeLanguage($(this).data('language'));
    })
	
});